"use strict";
/*
 * Created on 16.10.2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var IngredientConverter_1 = require("./conversions/IngredientConverter");

var IngredientConverterImpl_1 = require("./conversions/IngredientConverterImpl");

var RecipeConverter_1 = require("./conversions/RecipeConverter");

var RecipeConverterImpl_1 = require("./conversions/RecipeConverterImpl");
/**
 * @author Adam Drda
 */


var RecipeAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(RecipeAppModule, _AppModule_1$AppModul);

  function RecipeAppModule() {
    var _this;

    _classCallCheck(this, RecipeAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RecipeAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'recipe';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(RecipeAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(IngredientConverter_1.IngredientConverter).to(IngredientConverterImpl_1.IngredientConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(RecipeConverter_1.RecipeConverter).to(RecipeConverterImpl_1.RecipeConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return RecipeAppModule;
}(AppModule_1.AppModule);

exports.RecipeAppModule = RecipeAppModule;